import React, { useEffect, useRef } from 'react';

import { Month, MonthYearPickerContainer, Year, YearSection } from './styles';

export interface MonthYearPickerProps {
  currentDate: Date;
  onSelect: (date: Date) => void;
  onClose: () => void;
  isStartDate?: boolean;
  startDate?: Date;
  endDate?: Date;
}

export const MonthYearPicker: React.FC<MonthYearPickerProps> = ({ currentDate, onSelect }) => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const selectedYear = currentDate.getFullYear();
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Generate years from today's year -50 to +100
  const years = Array.from({ length: 151 }, (_, i) => currentYear - 50 + i);

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const selectedYearRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to selected year when component mounts
  useEffect(() => {
    if (scrollContainerRef.current && selectedYearRef.current) {
      selectedYearRef.current.scrollIntoView({
        block: 'center',
      });
    }
  }, [selectedYear]);

  return (
    <div>
      {/* Years with months grid */}
      <MonthYearPickerContainer
        ref={scrollContainerRef}
        style={{ maxHeight: '300px', overflowY: 'auto' }}
      >
        {years.map((year) => (
          <YearSection key={year} ref={year === selectedYear ? selectedYearRef : null}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '24px',
              }}
            >
              {/* Year section */}
              <div style={{ minWidth: '80px' }}>
                <Year isSelected={currentDate.getFullYear() === year}>{year}</Year>
              </div>

              {/* Months section */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: '4px',
                  flex: 1,
                }}
              >
                {months.map((month, index) => (
                  <Month
                    key={`${year}-${month}`}
                    onClick={() => onSelect(new Date(year, index, 1))}
                    isSelected={
                      currentDate.getFullYear() === year && currentDate.getMonth() === index
                    }
                  >
                    {month}
                  </Month>
                ))}
              </div>
            </div>
          </YearSection>
        ))}
      </MonthYearPickerContainer>
    </div>
  );
};
